import { useEffect } from "react"
import {
  Block,
  Button,
  CheckCircle,
  HeadingXSmall,
  LabelMedium,
  ListItem,
  ListItemLabel,
  ModalBody,
  ModalFooter,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { useNavigate } from "@tanstack/react-router"

import confetti from "#/assets/confetti.png"
import itemBackground from "#/assets/market-item-modal-background.png"
import storeThumb from "#/assets/store/taho-og-nft.jpg"
import { selectOpenModal, useDappSelector } from "#/redux-state"
import { routes } from "#/shared/constants"
import { BaseModal, BaseModalProps } from "#/ui/Modal"

export default function MarketTahoNFTItemModalSuccess({
  isOpen,
  onClose,
}: BaseModalProps) {
  const navigate = useNavigate()
  const [css, theme] = useStyletron()

  const openModal = useDappSelector(selectOpenModal)

  useEffect(() => {
    if (openModal === "taho-nft-store-item-success") {
      navigate({ to: `${routes.STORE}?success=true` })
    }
  }, [openModal, navigate])

  const closeModalHandler = () => {
    onClose?.({})
  }

  return (
    <BaseModal isOpen={isOpen} onClose={closeModalHandler} closeable>
      <Block
        as="img"
        src={confetti}
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        className={css({ objectFit: "cover" })}
      />
      <ModalBody
        className={css({
          height: "100%",
          paddingBottom: "80px",
          position: "relative",
        })}
      >
        <Block
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="flex-end"
          height="100%"
        >
          <CheckCircle size={52} color={theme.colors.black} />
          <HeadingXSmall
            marginTop={theme.sizing.scale600}
            marginBottom={theme.sizing.scale900}
          >
            Sucessfully collected
          </HeadingXSmall>
          <ListItem
            artwork={() => (
              <Block
                position="relative"
                width="100%"
                height="100%"
                padding={theme.sizing.scale500}
                overflow="hidden"
                overrides={{
                  Block: {
                    style: () => ({ borderRadius: theme.borders.radius200 }),
                  },
                }}
              >
                <Block
                  as="img"
                  src={itemBackground}
                  position="absolute"
                  top={0}
                  left={0}
                  width="100%"
                  height="100%"
                  className={css({ objectFit: "cover" })}
                />
                <Block
                  as="img"
                  src={storeThumb}
                  position="relative"
                  className={css({ zIndex: 2 })}
                />
              </Block>
            )}
            overrides={{
              Root: {
                style: () => ({
                  borderWidth: "2px",
                  borderColor: theme.colors.gray100,
                  borderRadius: theme.borders.radius300,
                  background: theme.colors.white,
                }),
              },
              ArtworkContainer: {
                style: () => ({
                  width: theme.sizing.scale3200,
                  height: theme.sizing.scale3200,
                  padding: theme.sizing.scale600,
                }),
              },
            }}
          >
            <ListItemLabel
              description={
                <ParagraphSmall color={theme.colors.contentSecondary}>
                  TahoxMezo Exclusive NFT
                </ParagraphSmall>
              }
            >
              <LabelMedium
                as="span"
                display="inline-block"
                marginBottom={theme.sizing.scale100}
              >
                TahoxMezo NFT
              </LabelMedium>
            </ListItemLabel>
          </ListItem>
        </Block>
      </ModalBody>
      <ModalFooter
        className={css({
          position: "relative",
          zIndex: 2,
        })}
      >
        <Button
          width="100%"
          onClick={closeModalHandler}
          size="large"
          kind="secondary"
        >
          Back to store
        </Button>
      </ModalFooter>
    </BaseModal>
  )
}
